import { useAppState } from 'AppContextProvider'
import ReinforcementScreenContainer from 'Components/ReinforcementScreen/ReinforcementMain'
import { FC, useMemo } from 'react'
import { Trans } from 'react-i18next'
import { ReinforcementDescriptionHighlight, ReinforcementTitleHighlight } from '../Typography'
import { ReinforcementScreenBackgrounds, ReinforcementScreenContent } from 'types/reinforcementScreenTypes'
import { images } from 'images'

const stepImages: ReinforcementScreenBackgrounds<FastingKnowledge> = {
  o: {
    nothing: images.experienceInfoNothing,
    a_bit: images.experienceInfoABit,
    expert: images.experienceInfoExpert
  }
}

interface ExperienceInfoScreenProps {
  onContinue: (shouldSkipNext?: boolean) => Promise<void>
}

const ExperienceInfoScreen: FC<ExperienceInfoScreenProps> = ({ onContinue }) => {
  const { appState } = useAppState()

  const screenContent = useMemo((): ReinforcementScreenContent => {
    const { fasting_knowledge: fastingKnowledge = 'nothing' } = appState.selections ?? {}
    const gender = 'o' as IGender // universal
    return {
      localePrefix: `reinforcementScreens.experience_info.${gender}.${fastingKnowledge}`,
      backgroundImagePath: stepImages[gender]![fastingKnowledge as FastingKnowledge]
    }
  }, [appState.selections?.fasting_knowledge])

  return (
    <ReinforcementScreenContainer
      title={
        <Trans
          i18nKey={`${screenContent.localePrefix}.title`}
          components={{ em: <ReinforcementTitleHighlight /> }}
        />
      }
      description={
        <Trans
          i18nKey={`${screenContent.localePrefix}.body`}
          components={{ em: <ReinforcementDescriptionHighlight /> }}
        />
      }
      backgroundImage={screenContent.backgroundImagePath}
      onContinue={onContinue}
    />
  )
}

export default ExperienceInfoScreen
